<a href="javascript:;" (click)="downloadFile()">{{
  'Project::ClickHereToDownloadProjectExport' | abpLocalization
}}</a
>&nbsp;
<i>{{ notification.project }}</i>
(<i>v{{ notification.version }}</i
>)
